import { IQueryPaginationResponse, useQueryPagination } from "@/services/adapterPaginations"
import { Dispatch, useState } from "react"
import { PayloadProps } from "./getResume"

export type TOrder = {
    "cliente": string,
    "criador": string,
    "dataGeracao": string,
    "idAuditoria": number,
    "pedido": string,
    "skus": number,
    "status": number
}

export interface IUseOrders extends IQueryPaginationResponse<TOrder> {
    orderSelected: TOrder | undefined,
    setOrderSelected: Dispatch<TOrder | undefined>,

}

export const useOrders = ({
    body
}: { body: PayloadProps }): IUseOrders => {
    const [orderSelected, setOrderSelected] = useState<TOrder>()

    const res = useQueryPagination<TOrder>('/acompanhamento/auditoria/expedicao/cabecalho', body, undefined, true)

    return {
        orderSelected,
        setOrderSelected,
        ...res
    }
}